import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/feature-blank-content';

Component('tr-feature-blank-content', {
  properties: {
    name: {
      type: String,
    },
    id: {
      type: Number,
    },
    logUrl: {
      type: String,
    },
  },
  mixins: [eventListenerMixin],
  connected() {
    this.listenTo(this.querySelector('.video-guide-link'), 'click', this.onGuideLinkClick.bind(this));
  },
  disconnected() {
    this.stopListening();
  },
  onGuideLinkClick(e) {
    e.preventDefault();
    e.stopPropagation();

    let videoGuide = this.querySelector('template').content.cloneNode(true);
    document.body.appendChild(videoGuide);
    const videoGuideTag = 'tr-feature-video-guide';
    videoGuide = document.querySelector(videoGuideTag);
    this.listenTo(videoGuide, `${videoGuideTag}:play`, () => {
      this.sendLogBehavior('videoplay');
    });
    this.listenTo(videoGuide, `${videoGuideTag}:ended`, () => {
      this.sendLogBehavior('videoended');
    });
    this.listenTo(videoGuide, `${videoGuideTag}:closed`, (event) => {
      this.sendLogBehavior('videoclosed', {
        currentTime: event.detail.currentTime,
      });
    });
    this.sendLogBehavior('clicklink');
  },
  sendLogBehavior(action, extraValues = {}) {
    $.ajax({
      type: 'POST',
      url: this.logUrl,
      dataType: 'json',
      data: {
        resource_type: 'FeatureBlankContent',
        resource_id: this.id,
        behavior_action: `tr-feature-blank-content:${action}`,
        extra_values: { name: this.name, ...extraValues },
      },
    }).catch(e => console.error(e));
  },
});
